<div class="aya-supplement-items">
  <div class="aya-supplement-items__title">{{ title }}</div>
  <ul>
    <li class="aya-supplement-items__options" *ngFor="let item of items">{{ item }}</li>
  </ul>
</div>
